module.exports = __webpack_public_path__ + "img/SHIELD.e90d9e59.svg";